import React, { Component } from 'react';
import {
    Grid, Row, Col, Table
} from 'react-bootstrap';
import SweetAlert from "react-bootstrap-sweetalert";

import Card from '../../components/Card/Card.jsx';
import NotificationService from '../../services/NotificationService.js';
import './notification.css';


class NotificationPage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      alert: null,
      notificaciones: null,
    };
    this.hideAlert = this.hideAlert.bind(this);
    this.errorAlert = this.errorAlert.bind(this);
    this.clickNotificacion = this.clickNotificacion.bind(this);
    this.notificationService = new NotificationService();
  }

  componentWillMount() {
    this.notificationService.getAllNotifications()
    .then(res => {
      this.setState({notificaciones: res.notificaciones})
    })
    .catch(err => {
      this.errorAlert(
        <div>
          Ha ocurrido un error mientras se obtenian los datos,
          el servidor ha devuelto la siguiente información: <p>{err.message}</p>
        </div>
      );
    })
  }
  hideAlert() {
    this.setState({
        alert: null,
    });
  }
  errorAlert(message) {
    this.setState({
      alert: (
        <SweetAlert
          error
          style={{ display: "block", marginTop: "-100px" }}
          title="Error"
          onConfirm={() => this.hideAlert()}
          onCancel={() => this.hideAlert()}
          confirmBtnBsStyle="danger"
          confirmBtnText="Aceptar"
        >
          {message}
        </SweetAlert>
      )
    });
  }

  clickNotificacion(path, id) {
    this.notificationService.markNotificationAsRead(id)
    .then(res => {
      this.props.history.push(path);
    });
  }

  drawNotificaciones() {
    const html = this.state.notificaciones.map((item, index) => {
      const fecha = new Date(item.created);
      if (parseInt(item.leida, 10)) {
        return (
          <tr key={index} onClick={() => this.props.history.push(item.path)} style={{cursor: 'pointer'}}>
            <td>{fecha.toLocaleString()}</td>
            <td>{item.nombre}</td>
            <td>{item.descripcion}</td>
            <td style={{textAlign: 'right'}}>{item.username}</td>
          </tr>
        );
      } else {
        return (
          <tr
            key={index} onClick={() => this.clickNotificacion(item.path, item.id)}
            className={'unred-notification'} style={{cursor: 'pointer'}}
          >
            <td><strong>{fecha.toLocaleString()}</strong></td>
            <td><strong>{item.nombre}</strong></td>
            <td><strong>{item.descripcion}</strong></td>
            <td style={{textAlign: 'right'}}><strong>{item.username}</strong></td>
          </tr>
        );
      }
    });
    return (
      <Table responsive hover>
        <thead>
          <tr>
            <th style={{textAlign: 'left'}}>Fecha</th>
            <th>Nombre</th>
            <th>Detalle</th>
            <th style={{textAlign: 'right'}}>Creada por</th>
          </tr>
        </thead>
        <tbody>
          {html}
        </tbody>
      </Table>
    );
  }
  render() {
    return (
      <div className="main-content">
        {this.state.alert}
        <Grid fluid>
          <Row>
            <Col md={12}>
              <Card
                title="Notificaciones"
                content={
                  <div>
                    {!this.state.notificaciones || this.state.notificaciones.length === 0 ?
                      <div>No tienes notificaciones!</div> :
                      <div>{this.drawNotificaciones()}</div>
                    }
                  </div>
                }
              />
            </Col>
          </Row>
        </Grid>
      </div>
      );
    }
}

export default NotificationPage;



// WEBPACK FOOTER //
// ./src/views/Pages/NotificationPage.jsx